import React from 'react'
import { BsLinkedin, BsInstagram, BsGithub} from  'react-icons/bs'
import {FaFacebookF} from 'react-icons/fa';



const SocialMedia = () => {
  return (
    <div className="app__social">
       
        <div>
          <a href="https://www.linkedin.com/in/tobias-hungwe-4a7b73184/"> <BsLinkedin/></a>
        </div>
        <div>
            <a href="https://www.facebook.com/tobias.hungwe.7"><FaFacebookF/></a>
        </div>
        <div>
          <a href="https://github.com/tobiashungwe"> <BsGithub/></a>
        </div>
        <div>
            <a href="https://www.instagram.com/hungwevision/"><BsInstagram/></a>
        </div>
    </div>
  )
}



export default SocialMedia